import { trpc } from '../lib/trpc';
import type { AddOnType } from '../../../shared/config/subscription-addons';
import { getAddOnConfig, calculateAddOnUnits as sharedCalculateUnits, calculateAddOnPrice as sharedCalculatePrice } from '../../../shared/config/subscription-addons';

/**
 * 追加オプション購入用フック
 */
export function useAddOnPurchase() {
  const utils = trpc.useUtils();

  const addMutation = trpc.subscriptionAddon.addAddOn.useMutation({
    onSuccess: async () => {
      // 使用状況を再取得（awaitでキャッシュ無効化完了を待つ）
      await utils.subscriptionAddon.getUsage.invalidate();
      await utils.subscriptionAddon.listAddOns.invalidate();
      // 請求書一覧も無効化（追加オプション購入で新しい請求書が作成されるため）
      await utils.stripe.listInvoices.invalidate();
      // 会社情報も無効化（subscriptionAddonUnits が更新されるため）
      await utils.company.getCurrentCompany.invalidate();
    },
  });

  const removeMutation = trpc.subscriptionAddon.removeAddOn.useMutation({
    onSuccess: async () => {
      // 使用状況を再取得（awaitでキャッシュ無効化完了を待つ）
      await utils.subscriptionAddon.getUsage.invalidate();
      await utils.subscriptionAddon.listAddOns.invalidate();
      // 請求書一覧も無効化
      await utils.stripe.listInvoices.invalidate();
      // 会社情報も無効化（subscriptionAddonUnits が更新されるため）
      await utils.company.getCurrentCompany.invalidate();
    },
  });

  return {
    addAddOn: addMutation.mutate,
    addAddOnAsync: addMutation.mutateAsync,
    removeAddOn: removeMutation.mutate,
    removeAddOnAsync: removeMutation.mutateAsync,
    isAddingAddOn: addMutation.isPending,
    isRemovingAddOn: removeMutation.isPending,
    addError: addMutation.error,
    removeError: removeMutation.error,
  };
}

/**
 * 追加オプション料金を計算
 */
export function calculateAddOnPrice(type: AddOnType, quantity: number): number {
  return sharedCalculatePrice(type, quantity);
}

/**
 * 追加オプション数量を正規化（単位に切り上げ）
 */
export function normalizeAddOnQuantity(type: AddOnType, quantity: number): number {
  const config = getAddOnConfig(type);
  const units = sharedCalculateUnits(type, quantity);
  return units * config.unit;
}
